import { StyleProp, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { nativewindWrapSvg } from './wrapSvg';

function DropdownIconRaw({
  style,
  fill,
  stroke,
}: {
  style?: StyleProp<ViewStyle>;
  fill?: string;
  className?: string;
  stroke?: string;
}) {
  return (
    <Svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={fill}
      stroke={stroke}
      style={style}
    >
      <Path
        d="M12 6L8 10L4 6"
        stroke={stroke}
        fillOpacity={0}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export const DropdownIcon = nativewindWrapSvg(DropdownIconRaw);
